<template>
  <section id="" class="page-content">
    <main>
      <Divider class="p-divider-horizontal mt-0" />
      <ScrollPanel style="height: 900px">
        <div id="templates">
          <div class="templates">
            <div class="subtitle" style="margin-bottom: .3em;">Templates</div>
            <Dropdown v-model="selectedTemplate" :options="templates" optionLabel="name" placeholder="Select template"
              @change="(event) => setTemplate(event.value)" appendTo="body" style="min-width:100%;" />
            <Divider class="divider-template" />
            <div class="action-buttons">
              <Button label="Save Template" class="p-button-raised" icon="pi pi-save" iconPos="left"
                style="float:right;margin-right:6px" @click="save(true)" />
              <Button label="Save as New Template" class="p-button-raised" icon="pi pi-save" iconPos="left"
                style="float:right;margin-right:6px" @click="save(false)" />
              <Button label="Delete Template" class="p-button-raised p-button-secondary" icon="pi pi-times" iconPos="left"
                style="float:right;margin-right:6px" @click="deleteTemp" />
            </div>
          </div>
          <div class="temp-info">
            <div>
              <label class="label">Name</label>
              <input class="input temp" type="text" placeholder="Template Name" v-model="template.name">
            </div>
            <div>
              <label class="label">Description</label>
              <textarea class="input temp" type="text" placeholder="Template Description"
                v-model="template.description"></textarea>
            </div>
            <div class="field">
              <label class="label">Schedule</label>
              <div class="control">
                <div class="select">
                  <select placeholder="Schedule" name="send_email" id="send_email" v-model="template.send_email">
                    <option enabled value></option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Additional Report Emails</label>
              <div class="control">
                <tag-input placeholder="Additional Report Emails" :checkFormat="false"
                  @updated="setExtraReportEmails($event)" :inputTags="template.extra_report_emails"></tag-input>
              </div>
            </div>
          </div>
        </div>
        <Divider class="filter-list" align="center">
          <div class="inline-flex align-items-center">
            <i class="pi pi-filter-fill mr-2"></i>
            <b>Filters</b>
          </div>
        </Divider>
        <div class="filters">
          <div class="filter">
            <label>Search</label>
            <div class="control">
              <input class="input" type="text" placeholder="Search for shipments..." v-model="template.filters.search"
                name="search" id="search">
            </div>
          </div>
          <div class="filter">
            <label>Shipment Status</label>
            <div class="control">
              <div class="select">
                <select v-model="template.filters.health" name="health" id="health" placeholder="Choose Shipment Status">
                  <option enabled value=""></option>
                  <option v-for="(value, key) in HEALTH" v-bind:value="key" v-bind:key="key">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="filter">
            <label>Tracking Request Status</label>
            <div class="control">
              <button-group-filter :collection="STATUS_FILTER" :target="template.filters.status" />
            </div>
          </div>
        </div>

        <div class="filters">
          <custom-filters :key="template.id" slot="body" :customFilters="customFilters"
            :previousFilters="template.filters" :previousTags="template.tags" :automatic="true"
            @apply="updateFilters($event)" />
        </div>

        <div v-if="template.tags.length > 0" class="filter-section">
          <Divider class="filter-list" align="center">
            <div class="inline-flex align-items-center">
              <i class="pi pi-filter-fill mr-2"></i>
              <b>Current filter list</b>
            </div>
          </Divider>
          <div v-for="(tag, index) in template.tags" :key="index" class="tags-container">
            <div class="tags-special">
              <Chip class="tag-special black">{{ tag.name }}</Chip>
              <Chip class="tag-special grey">{{ tag.type }}</Chip>
              <Chip class="tag-special green">{{ tag.value }}</Chip>
              <span class="close-icon" @click="removeFilter(tag, index)">&times;</span>
            </div>
          </div>
        </div>

        <Divider class="filter-list" align="center">
          <div class="inline-flex align-items-center">
            <i class="fa fa-lg fa-columns mr-2"></i>
            <b>Columns To Display</b>
          </div>
        </Divider>
        <div class="grid">
          <div v-for="(value, name) in schema" :id="name" :key="name" class="col-12">
            <label class="separator-title">{{ name.replace(/_/g, ' ') }}</label>
            <div class="p-inputgroup" style="max-width:99%;">
              <span class="p-inputgroup-addon">
                <i class="fa fa-lg fa-columns"></i>
              </span>
              <MultiSelect v-model="selectedColumns[name]" :options="value" :optionLabel="formatOptionLabel"
                placeholder="Select columns" display="chip" @change="updateColumns" appendTo="body" class="multi-select">
                <template v-slot:option="slotProps">
                  <div class="option-container">
                    <div class="option-text" :title="definitions[slotProps.option]">{{ slotProps.option.replace(/_/g, ' ').replace('.', ' -> ').replace('{}', '') }} - ({{ definitions[slotProps.option] }})</div>
                  </div>
                </template>
              </MultiSelect>
            </div>
          </div>
        </div>
      </ScrollPanel>
      <label>*_vslarrival_prediction are test fields.</label>
      <Button label="Reset" class="p-button-raised p-button-secondary" icon="pi pi-sync" iconPos="left"
        style="float:right;margin-right:6px" @click="reset" />
      <Button label="Export" class="p-button-raised" icon="pi pi-file" iconPos="left" style="float:right;margin-right:6px"
        @click="exportList" />
    </main>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { filterElementsShipmentList, mapFilterTypes } from '@/models/filters/FilterTypes'
import definitions from '@/assets/variables/fieldDefinitions'
import ButtonGroupFilter from '@/components/ButtonGroupFilter'
import DateRangeFilter from '@/components/DateRangeFilter'
import Pagination from '@/components/Pagination'
import Spinner from '@/components/Spinner'
import TagInput from '@/components/TagInput'
import CustomFilters from '@/components/CustomFilters'

import Shipment from '@/models/shipment'
export default {
  name: 'exportShipmentList',
  components: { ButtonGroupFilter, DateRangeFilter, Pagination, Spinner, TagInput, CustomFilters },
  mounted () {
    this.$emit('loading')
    const promises = [
      this.getCarriers().then(response => {
        this.carriers = response
        this.getMilestones().then(response => {
          this.milestones = response
          this.customFilters = filterElementsShipmentList()
          this.filterTypes = mapFilterTypes()
        })
      }),
      this.getCodeTypes().then(response => { this.codeTypes = response }),
      this.getTemplates().then(response => {
        this.templates = JSON.parse(JSON.stringify(response))
        this.defaultTemplates = response
      }),
      this.getShipmentFields().then(response => { this.schema = response })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      definitions,
      schema: [],
      HEALTH: Shipment.HEALTH,
      STATUS_FILTER: Shipment.STATUS_FILTER,
      objects: [],
      codeTypes: [],
      carriers: [],
      milestones: [],
      loadingTable: false,
      defaultTemplates: [],
      templates: [],
      template: this.initializeTemplate(),
      generating: false,
      selectedTemplate: null,
      openFilters: false,
      customFilters: [],
      filterTypes: [],
      selectedColumns: []
    }
  },
  methods: {
    ...mapActions({
      getCarriers: 'carrier/list',
      getMilestones: 'milestone/list',
      getCodeTypes: 'codeType/list',
      getTemplates: 'template/list',
      saveTemplate: 'template/save',
      updateTemplate: 'template/update',
      deleteTemplate: 'template/delete',
      exportShipments: 'shipment/export',
      getShipmentFields: 'shipmentFields/list'
    }),

    /**
     ** Saves the template data.
     * @param {boolean} update - Indicates whether it's an update operation (true) or a new save operation (false).
     */
    save (update) {
      let data = {
        template: this.template,
        update: update
      }

      this.saveTemplate(data).then(response => {
        if (update) {
          for (let i = 0; i < this.defaultTemplates.length; i++) {
            if (this.template.id === this.defaultTemplates[i].id) {
              this.defaultTemplates.splice(i, 1, JSON.parse(JSON.stringify(this.template)))
            }
          }
          for (let i = 0; i < this.templates.length; i++) {
            if (this.template.id === this.templates[i].id) {
              this.templates.splice(i, 1, JSON.parse(JSON.stringify(this.template)))
            }
          }
        } else {
          this.template.id = response.id
          this.defaultTemplates.push(JSON.parse(JSON.stringify(this.template)))
          this.templates.push(JSON.parse(JSON.stringify(this.template)))
        }

        this.selectedTemplate = this.template
      })
    },

    /**
     ** Deletes the template.
     * @returns {void}
     */
    deleteTemp () {
      if (!this.template.id) {
        this.template = this.initializeTemplate()
        return
      }
      this.deleteTemplate(this.template).then(response => {
        this.$delete(this.templates, this.templates.map(function (x) { return x.id }).indexOf(this.template.id))
        this.$delete(this.defaultTemplates, this.defaultTemplates.map(function (x) { return x.id }).indexOf(this.template.id))
        this.reset()
      })
    },

    /**
     ** Resets the state by initializing a new template and clearing selectedTemplate and selectedColumns.
     * @returns {void}
     */
    reset () {
      this.template = this.initializeTemplate()
      this.selectedTemplate = null
      this.selectedColumns = []
    },

    /**
     ** Sets the value of 'extra_report_emails' property in the template object using Vue Set.
     * @param {any} value - The value to be set for 'extra_report_emails' property.
     */
    setExtraReportEmails (value) {
      // Added just in case this needed a Vue Set
      this.$set(this.template, 'extra_report_emails', value)
    },

    /**
     ** Sets the template object with the provided template data.
     * @param {Object} temp - The template data to be set.
     */
    setTemplate (temp) {
      this.$set(this, 'template', JSON.parse(JSON.stringify(temp)))
      this.selectColumnsAutomatically()
      this.template.tags = this.updateTags()
      this.$forceUpdate()
    },

    /**
     ** Exports the list based on the selected columns and filters in the template. Displays an error notification if no columns are selected.
     * @returns {void}
     */
    exportList () {
      if (this.template.columns.length === 0) {
        this.$notify({
          group: 'global',
          title: 'Error',
          text: 'Select columns to display',
          duration: 4000,
          type: 'error'
        })
        return
      }
      document.body.style.cursor = 'wait'
      var params = Object.assign(
        this.template.filters,
        { column: this.template.columns },
        { filename: this.template.name || 'shipments' }
      )
      this.setURLQueryParams(params)
      this.generating = true
      this.exportShipments(params).then(response => {
        document.body.style.cursor = 'default'
        this.generating = false
      }).catch(error => {
        this.generating = false
        document.body.style.cursor = 'default'
        throw error
      })
    },

    /**
     ** Updates the filters in the template based on the provided object. Initializes the template if the filters object is empty.
     * @param {Object} obj - The object containing the filters to update.
     */
    updateFilters (obj) {
      if (Object.keys(obj.filters).length === 0) {
        this.template = this.initializeTemplate()
        this.template = JSON.parse(JSON.stringify(this.template))
      } else {
        // this.template.filters = { ...this.template.filters, ...obj.filters }
        for (const key in obj.filters) {
          if (obj.filters.hasOwnProperty(key)) {
            const value = obj.filters[key]
            if (value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)) {
              this.template.filters[key] = value
            }
          }
        }
        this.template.tags = this.updateTags()
        this.template = JSON.parse(JSON.stringify(this.template))
      }
    },

    /**
     ** Updates the tags based on the current template filters.
     * @returns {Array} An array of tags representing the applied filters.
     */
    updateTags () {
      const tags = []

      for (const filterKey in this.template.filters) {
        let filterValue = this.template.filters[filterKey]
        const filterElement = this.customFilters.find(filter => filterKey.includes(filter.code))
        if (!filterElement) continue

        const key = filterElement.code

        for (const filterType of filterElement.types) {
          const filterTypeData = this.filterTypes[filterType]
          if (!filterTypeData) continue

          const params = filterTypeData.params
          const codeParams = params.length > 0 ? params.map(param => key + '_' + param) : [key]

          if (params.length > 0) {
            for (const param of filterTypeData.params) {
              if (!filterKey.includes(param)) continue

              if (filterValue || (param === 'isnull' && filterValue === false)) {
                const existingTag = tags.find(tag => tag.name === filterElement.name && tag.type === filterTypeData.name)
                if (existingTag) existingTag.value += ` To ${filterValue}`
                else {
                  if (param === 'isnull') filterValue = filterValue ? 'No' : 'Yes'
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: filterValue
                  })
                }
              }
            }
          } else {
            const paramName = `${filterKey}`
            let value = filterValue

            if ((Array.isArray(value) && value.length > 0) || (!Array.isArray(value) && value)) {
              if (paramName === 'carrier' && Array.isArray(value) && value.length > 0) {
                value.forEach(id => {
                  const carrier = this.carriers.find(carrier => carrier.id === parseInt(id))
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: carrier.official_name,
                    id: carrier.id
                  })
                })
              } else if (paramName === 'shipment_status' && Array.isArray(value) && value.length > 0) {
                value.forEach(id => {
                  const milestone = this.milestones.find(milestone => milestone.id === parseInt(id))
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: milestone.description,
                    id: milestone.id
                  })
                })
              } else {
                tags.push({
                  name: filterElement.name,
                  type: filterTypeData.name,
                  code: codeParams,
                  value: value
                })
              }
            }
          }
        }
      }

      return tags
    },

    /**
     ** Removes the specified filter and its associated tag from the template.
     * @param {Object} tag - The filter tag to be removed.
     * @param {number} index - The index of the filter tag in the template.
     */
    removeFilter (tag, index) {
      if (tag.code[0] === 'carrier') this.template.filters.carrier = this.template.filters.carrier.filter(id => id !== tag.id)
      else if (tag.code[0] === 'shipment_status') this.template.filters.shipment_status = this.template.filters.shipment_status.filter(id => id !== String(tag.id))
      else this.template.filters[tag.code[0]] = null
      if (tag.code[1]) this.template.filters[tag.code[1]] = null

      // Remove the filter tag with the provided key
      this.template.tags.splice(index, 1)
      this.template = JSON.parse(JSON.stringify(this.template))
    },

    /**
     ** Formats the label for an option in the multi-select dropdown.
     * @param {string} option - The option to be formatted.
     * @returns {string} - The formatted label for the option.
     */
    formatOptionLabel (option) {
      return option ? option.replace(/_/g, ' ').replace('.', ' -> ').replace('{}', '') : ''
    },

    /**
     ** Updates the selected columns in the template based on the user's selection. Clears the template columns and adds the selected columns from the schema.
     * @returns {void}
     */
    updateColumns () {
      this.template.columns = []
      for (const name of this.schemaKeys) {
        const selected = this.selectedColumns[name]
        if (selected && selected.length > 0) {
          this.template.columns.push(...selected)
        }
      }
    },

    /**
     ** Automatically selects columns in the schema based on the existing template columns. Iterates through each schema key and selects columns that match the schema.
     * @returns {void}
     */
    selectColumnsAutomatically () {
      for (const name of this.schemaKeys) {
        const selected = this.template.columns.filter(item => this.schema[name].includes(item))
        this.$set(this.selectedColumns, name, selected)
      }
    },

    /**
     ** Initializes a new template object with default values. Returns an object containing empty arrays for extra_report_emails and columns, and initializes filters and tags using the initializeFilters method.
     * @returns {void}
     */
    initializeTemplate () {
      return {
        extra_report_emails: [],
        filters: this.initializeFilters(),
        columns: [],
        tags: []
      }
    },

    /**
     ** Initializes a new filters object with default values based on predefined filter elements and types. Returns an object containing default values for each filter element and type.
     * @returns {void}
     */
    initializeFilters () {
      const filterTemplate = {}
      const filterTypes = mapFilterTypes()
      const filterElements = filterElementsShipmentList()

      filterElements.forEach(element => {
        const code = element.code
        const types = element.types

        types.forEach(type => {
          const filterType = filterTypes[type]
          const params = filterType.params.reduce((accumulator, param) => {
            accumulator[`${code}_${param}`] = null
            return accumulator
          }, {})

          Object.assign(filterTemplate, params)
        })
      })

      filterTemplate.search = ''
      filterTemplate.status = []
      filterTemplate.health = []
      filterTemplate.dta = ''
      filterTemplate.order_dta = ''
      filterTemplate.pol_loc = ''
      filterTemplate.pod_loc = ''
      filterTemplate.carrier = []
      filterTemplate.shipment_status = []

      return filterTemplate
    },

    /**
     ** Sets URL query parameters based on the provided params object. Removes any parameters with null, undefined, or empty string values.
     * @returns {void}
     */
    setURLQueryParams (params) {
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key]
        }
      })
    }
  },
  computed: {
    schemaKeys () {
      return Object.keys(this.schema)
    },
    ...mapState({
      count: state => state.shipment.count
    })
  },
  watch: {
  }
}
</script>
<style lang="scss">
.filters {
  display: block;
}

.filter {
  display: inline-block;
  margin-left: 0;
  margin-right: 1em;
}

.templates {
  display: inline-block;
  vertical-align: top;
  width: 39%;
  min-width: 300px;
  margin-right: 1%;
}

#templates {
  margin-bottom: 1em;
}

.temp-info {
  display: inline-block;
  width: 58%;
  min-width: 300px;
  margin-right: 1%;
}

.action-buttons {
  vertical-align: top;
  min-width: 120px;
  display: inline-block;
  margin-left: 9px;

  .p-button {
    width: 100%;
    margin: .2em 0;
  }
}

.separator-title {
  text-transform: capitalize;
  font-size: 15px;
  font-weight: 600;
}

.separator {
  background: white;
}

.divider-template {
  margin: 2.5rem 0px 2.5rem 0px !important;
}

.p-multiselect .p-multiselect-label {
  display: flex;
  flex-wrap: wrap;
}

.p-multiselect .p-multiselect-token {
  margin-bottom: .5rem
}

.tags-special {
  align-items: center;
  gap: 3px;
}

.tag-special {
  border-radius: 5px !important;
  color: #fff !important;

  &.black {
    background-color: black;
  }

  &.grey {
    background-color: grey;
  }

  &.green {
    background-color: #009c95;
  }
}

.filter-list .p-divider-content {
  background-color: #F5F7FA !important;
}

.p-divider-solid.p-divider-horizontal:before {
  border-top-style: solid !important;
}

.option-container {
  display: flex;
  align-items: center;
}

.option-text {
  max-width: 45vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageExport.vue